import ApiServiceWrapper from './../../api-request.service';

const preffileReportApi = {
  getPreffileReport(payload: { username: string }) {
    const url: string = `reports/get-preffile-report?requsername=${payload.username}&repname=preffile&isforced=true&pageno=&noofrec=&productgroupid=`;
    return ApiServiceWrapper.get(url);
  },
};

export default preffileReportApi;
